// sorting is important, DO NOT CHANGE ORDER WITHOUT CONSULTING!
// buttons will be ordered in this order from left to right
export const semanticButtonVariantAbort = [
  'reset',
  'resetFilters',
  'cancel',
  'close',
  'back',
  'forward',
] as const;
export const semanticButtonVariantDanger = [
  'delete',
] as const;
export const semanticButtonVariantMutation = [
  'edit',
  'saveAsNew',
  'save', // update
  'accept',
  'create',
  'upload', // special form of create for files
] as const;
export const semanticButtonVariantStandalone = [
  'add',
  'settings',
  'tableNavigation',
] as const;
export const semanticButtonVariantProcess = [
  'calculate',
  'revision',
] as const;
export const semanticButtonVariantChart = [
  'fullscreen',
  'optionMenu',
] as const;
export const semanticButtonVariant = [
  ...semanticButtonVariantProcess,
  ...semanticButtonVariantAbort,
  ...semanticButtonVariantDanger,
  ...semanticButtonVariantMutation,
  ...semanticButtonVariantStandalone,
  ...semanticButtonVariantChart,
] as const;

export type TSemanticButtonVariant = typeof semanticButtonVariant[number];

export const SEMANTIC_BUTTON_ICON_MAP: Record<TSemanticButtonVariant, string> = {
  accept: 'pi pi-check',
  add: 'pi pi-plus',
  back: 'pi pi-arrow-left',
  cancel: 'pi pi-times',
  close: 'pi pi-times',
  create: 'pi pi-plus',
  delete: 'pi pi-trash',
  edit: 'pi pi-pencil',
  forward: 'pi pi-arrow-right',
  reset: 'pi pi-undo',
  resetFilters: 'pi pi-filter-slash',
  save: 'pi pi-save',
  saveAsNew: 'pi pi-copy',
  settings: 'pi pi-cog',
  tableNavigation: 'pi pi-arrow-right',
  upload: 'pi pi-upload',
  calculate: 'pi pi-calculator',
  revision: 'pi pi-history',
  optionMenu: 'pi pi-ellipsis-v',
  fullscreen: 'pi pi-arrow-up-right-and-arrow-down-left-from-center',
};
